import React, { useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
var t = i18n.getFixedT(null, 'audit-log');
var gt = i18n.getFixedT(null, 'app');
var AuditLogDetail = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      onClose = props.onClose,
      data = props.data;
  var form_ref = useRef(null);
  var fields = {};

  _.set(fields, 'moduleName', {
    label: t('lbl-module-name')
  });

  _.set(fields, 'actionName', {
    label: t('lbl-action-name')
  });

  _.set(fields, 'target', {
    label: t('lbl-target')
  });

  _.set(fields, 'userName', {
    label: t('lbl-username')
  });

  _.set(fields, 'displayName', {
    label: t('lbl-display-name')
  });

  _.set(fields, 'ip', {
    label: t('lbl-ip')
  });

  _.set(fields, 'dateTime', {
    label: t('lbl-date-time')
  });

  _.set(fields, 'actionResult', {
    label: t('lbl-action-result'),
    formatter: function formatter(value) {
      if (value === 0) return /*#__PURE__*/React.createElement("div", null, t('lbl-action-result-success'));
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, t('lbl-action-result-failed'));
      return '';
    }
  });

  _.set(fields, 'severity', {
    label: t('lbl-severity'),
    formatter: function formatter(value) {
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-low'));
      if (value === 2) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-medium'));
      if (value === 3) return /*#__PURE__*/React.createElement("div", null, t('lbl-severity-high'));
      return '';
    }
  }); // dailog action


  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('lbl-detail'),
    global: true // info={error}
    // infoClassName={cx({'c-error':error})}
    ,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    value: data
  }));
});
AuditLogDetail.defaultProps = {
  id: 'g-audit-log-detail'
};
AuditLogDetail.propTypes = {
  id: PropTypes.string
};
export default AuditLogDetail;